import { NextCustomImage as Image } from 'components/Image';
import getCommonTestId from 'constants/testsIds/common';
import cx from 'classnames';
import * as S from './PinnedSubsectionCardStyles';

export type PinnedSubsectionCardProps = {
  label: string;
  url: string;
  icon?: string;
};

const PinnedSubsectionCard = ({ label, url, icon }: PinnedSubsectionCardProps) => (
  <S.PinnedSubsectionCard
    href={url}
    data-cy={getCommonTestId('PINNED_SUBSECTION_CARD')}
    type='notStyled'
  >
    {icon && (
      <Image
        src={icon}
        alt={`${label} ${icon}`}
        width={34}
        height={34}
        aria-hidden
      />
    )}
    <div className={cx({ 'lm-label': label.trim().toLowerCase() === 'loans and mortgages' })}>{label}</div>
  </S.PinnedSubsectionCard>
);

export default PinnedSubsectionCard;
